export default __webpack_public_path__ + "static/media/rfidImage.42bd2824.png";